export default __webpack_public_path__ + "static/media/exterior12.131aa21e.webp";